import type { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import toast from 'react-hot-toast'
import type { Game } from '@/redux/reducers/gameReducer'
import { DATE_FORMAT_HUMAN } from '@/utils/date-time-utils'
import { getLottoNameAndCountryFromLottoGame } from '@/utils/lotto-type-v2'
import { getBackgroundFlagGroup } from '@/utils/flag-utils'
import { formatDateTime, getResultNumber } from './result-card.utils'
import LottoCountryCard, {
  LottoCountryCardProps,
} from '@/ui-components/components/LottoCountryCard'
import { trans } from '@/i18n/utils'

const buildLottoGroupSections = (
  round: Game['rounds'][0],
  type: Game['type'],
  t: TFunction,
): LottoCountryCardProps['sections'] => {
  const sections: LottoCountryCardProps['sections'] = []
  const noRoundMessage = t('message.no_round') || 'No Round'

  if (type === 'group_six' && !round) {
    sections.push({
      title: t('betResult.six_group_result'),
      numbers: [noRoundMessage],
    })
  } else if (type === 'group' && !round) {
    sections.push({
      title: t('betResult.four_result'),
      numbers: [noRoundMessage],
    })
  }

  if (round) {
    if (type === 'group_six') {
      sections.push({
        title: t('betResult.six_group_result'),
        numbers: [getResultNumber(round.six_result)],
      })
    } else if (type === 'group') {
      sections.push({
        title: t('betResult.four_result'),
        numbers: [getResultNumber(round.four_result)],
      })
    }
  }
  if (!round?.is_result_confirmed) {
    return sections.map((i) => ({
      ...i,
      result: t('betResult.waiting'),
    }))
  }

  return sections
}

export const LottoGroupResultCard = ({
  game,
  rounds,
}: {
  game: Game
  rounds: Game['rounds']
}) => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()

  const { country, name: flagBackgroundName } =
    getLottoNameAndCountryFromLottoGame(game.type, game.flag)
  const round = rounds?.[0]
  const title = trans(i18n, game.translations, 'name')
  const closeAt = round?.close_at

  const onClick = () => {
    if (round?.id) {
      navigate(`/lotto/${game.code}/${game.id}/${round.id}`)
    } else {
      toast.error(t('message.no_round'))
    }
  }
  return (
    <LottoCountryCard
      key={`thai-lotto-${game.id}`}
      onClick={onClick}
      country={country}
      flagBackgroundName={getBackgroundFlagGroup(flagBackgroundName)}
      title={title}
      noRound={!round}
      sections={buildLottoGroupSections(round, game.type, t)}
      date={formatDateTime(DATE_FORMAT_HUMAN, closeAt, i18n.language)}
      time={formatDateTime('HH:mm', closeAt, i18n.language)}
    />
  )
}
